export const GET_DROPDOWN_VALUES_EU = "GET_DROPDOWN_VALUES_EU";
export const GET_FORM_NL = "GET_FORM_NL";
export const GET_FORM_CDS="GET_FORM_CDS";

export const SAVE_FORM_CDS = "SAVE_FORM_CDS";
export const SAVE_C88_ITEM = "SAVE_C88_ITEM";
export const SAVE_C88_DUTY = "SAVE_C88_DUTY";

export const SEARCH_DROPDOWN_VALUES_EU="SEARCH_DROPDOWN_VALUES_EU"


export const DELETE_C88_ENTITY_UK = "DELETE_C88_ENTITY_UK";
export const DELETE_ENTITY_CDS="DELETE_ENTITY_CDS";


export const GET_HS_MASTER_HS="GET_HS_MASTER_HS"
export const GET_PROCEDURE_CODE_VALUES ="GET_PROCEDURE_CODE_VALUES"
export const GET_SHIPMENT_NOTES ="GET_SHIPMENT_NOTES"
export const SAVE_SHIPMENT_NOTES ="SAVE_SHIPMENT_NOTES"
export const DELETE_SHIPMENT_NOTES = "DELETE_SHIPMENT_NOTES"
export const GET_AI_VALUES = "GET_AI_VALUES"
export const AI_DETAIL_STATEMENT = "AI_DETAIL_STATEMENT"
export const AI_DETAIL_DOCS = "AI_DETAIL_DOCS"

//items tab

export const SAVE_ITEM_CDS="SAVE_ITEM_CDS"

//  refresh data

export const INITIALIZE_CDS_FORM = "INITIALIZE_CDS_FORM"

//refresh Tariff
export const REFRESH_TARIFF_API = "REFRESH_TARIFF_API"

// download CDS Documents

export const GET_GENERATED_PDF_URL_CDS_DMS_TAX = "GET_GENERATED_PDF_URL_CDS_DMS_TAX"
// send to billing button api event
export const INVC_SEND_TO_BILLING = "INVC_SEND_TO_BILLING"







